import { render, staticRenderFns } from "./MenuLogotype.vue?vue&type=template&id=6dd9b0b4&scoped=true"
import script from "./MenuLogotype.vue?vue&type=script&lang=js"
export * from "./MenuLogotype.vue?vue&type=script&lang=js"
import style0 from "./MenuLogotype.vue?vue&type=style&index=0&id=6dd9b0b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd9b0b4",
  null
  
)

export default component.exports